import React from 'react';

// Section title shown as a grey tab resting on a full-width rule, so each home-page block is clearly delimited.
export const SectionHeading = ({ children, icon, right, testId, className = 'mb-5', shine = false }) => (
  <div className={`flex items-end justify-between gap-3 border-b border-[#404040] ${className}`} data-testid={testId ? `${testId}-bar` : undefined}>
    <h2 className={`${shine ? 'shine shine-soft ' : ''}inline-flex items-center gap-2 px-3.5 md:px-4 py-1.5 md:py-2 rounded-t-lg bg-white/10 text-lg md:text-2xl font-bold text-white -mb-px border-b-2 border-[#808080] tracking-tight`} data-testid={testId}>
      {icon && <span className="text-xl md:text-2xl leading-none">{icon}</span>}
      {children}
    </h2>
    {right && <div className="pb-2 shrink-0">{right}</div>}
  </div>
);

export default SectionHeading;
